<section class="section" id="contact">
  <div class="container contact">
    <div class="section-box">
      <div class="mb-4" data-animate="fadeInDown" data-animate-duration="1000">
        <h3 class="contact-pre-title big-subtitle">
          05. {{ "Contact.Pretitle" | translate }}
        </h3>
        <h4 class="e-font contact-title big-title"
            data-animate="typewriter"
            data-animate-delay="500">
          {{ "Contact.Title" | translate }}
        </h4>
      </div>
      <p data-animate="morphIn"
         data-animate-duration="1200"
         data-animate-delay="2500">
        {{ "Contact.Content" | translate }}
      </p>
      <div class="mt-5"
           data-animate="scaleIn"
           data-animate-duration="800"
           data-animate-delay="3500">
           <div class="contact-links" data-animate="fadeInUp" data-animate-duration="800" data-animate-delay="3000">
  <a href="https://github.com/jlassimolka" class="contact-link" target="_blank">
    <i class="fab fa-github"></i> github.com/jlassimolka
  </a>
  <a href="mailto:molka.jlassi09@gmail.com" class="contact-link" target="_blank">
    <i class="fas fa-envelope"></i> molka.jlassi09@gmail.com
  </a>
  
  <a href="https://www.linkedin.com/in/molka-jlassi-07b928225/" class="contact-link" target="_blank">
  <i class="fab fa-linkedin"></i> LinkedIn
</a>

</div>

        <app-dynamic-button
          class="contact-btn"
          [text]='"Contact.Btn" | translate'
          href="https://www.linkedin.com/in/molka-jlassi-07b928225/"
          target="_blank"
          analyticsEvent="click_send_mail"
          analyticsCategory="contact"
          analyticsLabel="email"
          variant="primary">
        </app-dynamic-button>
      </div>
    </div>
  </div>
</section>
